import type { Level } from "./types";

export async function loadLevel(path: string): Promise<Level> {
  const res = await fetch(path);
  if (!res.ok) throw new Error(`Level not found: ${path}`);
  return (await res.json()) as Level;
}
